/** Max backup refresh rate while typing; blankings are never throttled. */
export const CHANGE_CHECK_THROTTLE_MS = 2000;

/** A queued restore save is retried at the response queue's own interval, a few times. */
export const RESTORE_SAVE_RETRY_MS = 2000;
export const RESTORE_SAVE_ATTEMPTS = 4;

/** react-s-alert customFields.type values routed by AlertTemplate. */
export const essayRestoreAlertTypes = {
    BLANKED: 'essay_content_blanked',
    RESTORED: 'essay_content_restored',
};

export default {
    CHANGE_CHECK_THROTTLE_MS,
    RESTORE_SAVE_RETRY_MS,
    RESTORE_SAVE_ATTEMPTS,
    essayRestoreAlertTypes,
};
